"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("../../lib");

require("./styles.css");

var _common = require("../../common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SliderBar =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SliderBar, _PureComponent);

  function SliderBar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SliderBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SliderBar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "innerRef", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "moveKnob", function () {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var sliderContext = _this.props.sliderContext;
      var knobPos = sliderContext.knobPos,
          vertical = sliderContext.vertical;
      var direction = vertical ? 'top' : 'left';
      var value;

      if (knobPos) {
        value = index ? knobPos[index].pos : knobPos.pos;

        var style = _defineProperty({}, direction, "".concat(value, "px"));

        return style;
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "moveHighlight", function () {
      var _style2;

      var sliderContext = _this.props.sliderContext;
      var highlightStyles = sliderContext.highlightStyles,
          vertical = sliderContext.vertical;
      var direction = vertical ? 'top' : 'left';
      var directionPercentage = vertical ? 'height' : 'width';
      var style = (_style2 = {}, _defineProperty(_style2, direction, "".concat(highlightStyles.pos, "px")), _defineProperty(_style2, directionPercentage, "".concat(highlightStyles.percentage, "%")), _style2);
      return style;
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var propNames = ['fluid'];
      var names = [SliderBar.className];
      (0, _lib.addClassByPropName)(names, _this.props, propNames);
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "renderKnobs", function () {
      var sliderContext = _this.props.sliderContext;
      var onDragStart = sliderContext.onDragStart,
          knobRef = sliderContext.knobRef,
          knobPos = sliderContext.knobPos,
          vertical = sliderContext.vertical;
      var direction = vertical ? 'top' : 'left';

      if ((0, _lib.arrayHasItems)(knobPos)) {
        return knobPos.map(function (_ref, i) {
          var pos = _ref.pos,
              key = _ref.key;
          return _react.default.createElement("span", {
            key: key,
            role: "button",
            tabIndex: 0,
            onMouseDown: function onMouseDown(e) {
              return onDragStart(e, i);
            },
            style: _defineProperty({}, direction, "".concat(pos, "px")),
            className: "MHub-Slider-Knob",
            ref: knobRef
          });
        });
      }

      return _react.default.createElement("span", {
        role: "button",
        tabIndex: 0,
        onMouseDown: onDragStart,
        style: _this.moveKnob(),
        className: "MHub-Slider-Knob",
        ref: knobRef
      });
    });

    return _this;
  }

  _createClass(SliderBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          sliderContext = _this$props.sliderContext,
          fluid = _this$props.fluid,
          rest = _objectWithoutProperties(_this$props, ["sliderContext", "fluid"]);

      var trackRef = sliderContext.trackRef,
          onTrackClick = sliderContext.onTrackClick;
      var Wrapper = (0, _lib.getElementType)(this, this.props);
      var classNames = this.classNames();
      return _react.default.createElement(Wrapper, _extends({}, rest, {
        className: classNames
      }), this.renderKnobs(), _react.default.createElement("div", {
        className: "MHub-Slider-Track",
        role: "button",
        tabIndex: 0,
        onMouseDown: onTrackClick,
        ref: trackRef
      }), _react.default.createElement("div", {
        className: "MHub-Slider-Highlight",
        role: "button",
        tabIndex: 0,
        onMouseDown: onTrackClick,
        style: this.moveHighlight()
      }));
    }
  }]);

  return SliderBar;
}(_react.PureComponent);

exports.default = SliderBar;

_defineProperty(SliderBar, "className", 'MHub-Slider-Wrapper');

_defineProperty(SliderBar, "propTypes", {
  as: _common.customPropTypes.as,
  sliderContext: _propTypes.default.shape({
    onTrackClick: _propTypes.default.func,
    onDragStart: _propTypes.default.func,
    knobPos: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.object)]),
    highlightStyles: _propTypes.default.shape({
      pos: _propTypes.default.number,
      percentage: _propTypes.default.number
    }),
    knobRef: _common.customPropTypes.ref,
    trackRef: _common.customPropTypes.ref,
    vertical: _propTypes.default.bool
  }).isRequired,
  fluid: _propTypes.default.bool
});

_defineProperty(SliderBar, "defaultProps", {
  as: 'div',
  fluid: false
});